(function() { window.GUID_15e221c2_3002_40e3_a675_2fb29aedafc6 = { getGuid: function() { return "15e221c2-3002-40e3-a675-2fb29aedafc6"; } }; })();
CS.FormReady(function (formId) {
    if (formId == "ReplaceEntity") {
        var btnReplaceByBye = $('#BtnReplaceByBye');
        btnReplaceByBye.on('click', function (e) {
            e.preventDefault();
            document.NewEntityBaseId.val("0", "Bye");
        });
    }
});

//# sourceMappingURL=ReplaceEntity.js.map
